import { SentryRoute as Route } from '@occc-app/App/sentry';
import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';

import { routeCreator } from './touchpoint.router';
import { AdSetsListPage } from './features/ad-sets-list-page/ad-sets-list.page';
import { AdSetsDetailsPage } from './features/ad-sets-details-page';
import { AdSetsCreatePageContainer } from './features/ad-sets-create-page/ad-sets-create-page.container';
import { AdSetsEditPage } from './features/ad-sets-edit-page';
import { AssetsListPage } from './features/assets-list-page/assets-list-page.component';
import { AssetsDetailsPage } from './features/assets-details-page/assets-details-page.component';
import { AssetsCreatePage } from './features/assets-create-page/assets-create.page';
import { AssetsEditPage } from './features/assets-edit-page';
import { DefaultScreensListPage } from './features/default-screens-list-page';
import { DefaultScreensCreatePage } from './features/default-screens-create-page';
import { DefaultScreensEditPage } from './features/default-screens-edit-page';
import { SchedulePage } from './features/schedule-page';

export const touchpointRoutes = (
  <>
    <Route
      path={routeCreator.adSetsList()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_AD_SETS_VIEW}>
          <AdSetsListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.adSetsCreate()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_AD_SET_CREATE}>
          <AdSetsCreatePageContainer />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.adSetsDetails(':id')}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_AD_SET_VIEW}>
          <AdSetsDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.adSetsUpdate(':id')}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_AD_SET_EDIT}>
          <AdSetsEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.assetsList()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_ASSETS_VIEW}>
          <AssetsListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.assetsCreate()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_ASSET_CREATE}>
          <AssetsCreatePage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.assetsDetails(':id')}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_ASSET_VIEW}>
          <AssetsDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.assetsUpdate(':id')}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_ASSET_EDIT}>
          <AssetsEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.defaultScreensList()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_DEFAULT_SCREENS_VIEW}>
          <DefaultScreensListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.defaultScreensCreate()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_DEFAULT_SCREEN_CREATE}>
          <DefaultScreensCreatePage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.defaultScreensUpdate(':id')}
      element={
        <ProtectedRoute
          feature={[
            Feature.TOUCHPOINT_DEFAULT_SCREEN_EDIT,
            Feature.TOUCHPOINT_DEFAULT_SCREEN_EDIT_VIEW_ONLY,
          ]}
        >
          <DefaultScreensEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path={routeCreator.scheduleList()}
      element={
        <ProtectedRoute feature={Feature.TOUCHPOINT_AD_SETS_VIEW}>
          <SchedulePage />
        </ProtectedRoute>
      }
    />
  </>
);
